import { Fragment } from 'react';
import type { RichTextFormatter } from '@/domains/core/localization/translate';
export const formatSpan = (): {
  span: RichTextFormatter;
} => {
  let i = 0;
  return {
    span: (chunks: React.ReactNode[]) => {
      const res = <span key={i}>{chunks}</span>;
      i += 1;
      return res;
    }
  };
};
export const formatStrong = (): {
  strong: RichTextFormatter;
} => {
  let i = 0;
  return {
    strong: (chunks: React.ReactNode[]) => {
      const res = <strong key={i}>{chunks}</strong>;
      i += 1;
      return res;
    }
  };
};
export const formatBr = (): {
  linebreak: RichTextFormatter;
} => {
  let i = 0;
  return {
    linebreak: () => {
      i += 1;
      return <br key={i} />;
    }
  };
};
export const formatRemoveBr = (): {
  linebreak: RichTextFormatter;
} => {
  let i = 0;
  return {
    linebreak: () => {
      i += 1;
      return <Fragment key={i} />;
    }
  };
};